import React, { useState, useEffect } from 'react'
import CustomDatatableProductCategory from '../../components/CustomDatatableProductCategory/CustomDatatableProductCategory';
import './ProductCategoryList.css';
import { BiPlusMedical, BiSearchAlt } from 'react-icons/bi';
import { GoCloudDownload } from 'react-icons/go';
import { AiOutlineFileExcel } from 'react-icons/ai';
import AddOrEditProductCategory from '../../components/AddOrEditProductCategory/AddOrEditProductCategory';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import DeleteConfirmation from '../../components/DeleteConfirmation/DeleteConfirmation';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import { getProductCategories } from '../../services/http';
import { handleMenuSelection, handleSubMenuSelection, searchFunction, reload } from '../../utils/utils';
import Navbar from '../../appShell/Navbar/Navbar';
import Sidebar from '../../appShell/Sidebar/Sidebar';


const ProductCategory = () => {


  const tableColumns = [
    { id: "1", label: "#" },
    { id: "2", label: "Libellé" }
  ]

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const [totalPage, setTotalPage] = useState(1);
  const [search, setSearch] = useState("");

  const [displayLoader, setDisplayLoader] = useState(true);

  const states = useSelector((state) => state, shallowEqual);

  // To populate the breadcrumb and update the sidebar menu
  useEffect(async () => {
    dispatch({
      type: "SET",
      key: "breadcrumbContent",
      payload: {
        firstLevelText: "Paramètres", firstLevelLink: "", secondLevelText: "Catégorie de produits", secondLevelLink: "/product-category", thirdLevelText: "", thirdLevelLink: ""
      }
    });
    handleMenuSelection("settings", dispatch, states);
    handleSubMenuSelection("products-categories", dispatch)
  }, [])

const fetchProductCategories = async(page, search) => {
  let product_categories_list_response = await getProductCategories(states.userToken.access_token, page, search);
  let product_categories_list_response_copy = product_categories_list_response?.data.data?.map(obj => ({ ...obj, showEdit: false, showDelete: false }))
  console.log(product_categories_list_response_copy)
  const perPageValue = product_categories_list_response?.data?.per_page
  setPerPage(perPageValue)
  const total = product_categories_list_response?.data?.total;
  setTotalPage(Math.ceil(total/perPageValue))
  dispatch({
    type: "SET",
    key: "productCategoriesList",
    payload: product_categories_list_response_copy,
  });
  setDisplayLoader(false);
}

  useEffect(() => {
    fetchProductCategories(pageNumber, search)
    console.log(pageNumber)
    console.log(search)
  }, [pageNumber, search])

  const goToImportScreen = () => {
    navigate("/import-product-category")
  }

  const handleCloseDeleteModal = (id) => {
    let index = states.productCategoriesList.findIndex(x => x.id === id);
    let newTableData = [...states.productCategoriesList];
    newTableData[index].showDelete = false;

    dispatch({
      type: "SET",
      key: "productCategoriesList",
      payload: newTableData,
    });
  };
  const handleShowDeleteModal = (id) => {
    let index = states.productCategoriesList.findIndex(x => x.id === id);
    // console.log("index is : ", index)
    let newTableData = [...states.productCategoriesList];
    newTableData[index].showDelete = true;
    dispatch({
      type: "SET",
      key: "productCategoriesList",
      payload: newTableData,
    });
  };

  const handleSearchChange = (e) => {
    console.log(e.currentTarget.value)
    setSearch(e.currentTarget.value)
  }

    const changePage = ({ selected }) => {
        let currentPage = selected + 1;
        setPageNumber(currentPage)
    }

  return (
    <div>
      <Navbar />
      <div className="main-container" id="container">
        <Sidebar />

        <div id="content" className="main-content">
          <div className="layout-px-spacing">

            <div className="row layout-top-spacing">
              <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
              </div>
            </div>
            {/* <AddOrEditProductCategory operationType={"new"} show={states.showNewProductCategory} handleClose={() => navigate("/product-category/new")} /> */}
            <h2 className="my-3 text-left">Liste des catégories de produits</h2>
            {displayLoader == false ?
            <div className="widget widget-content widget-content-area">
              <div className="dataTables_wrapper  dt-bootsrap4">
                <div className="dt--top-section container-fluid mt-4 pt-3 px-3">
                  <div className="row">
                    <div className="col-12 col-sm-6 d-flex justify-content-sm-start justify-content-center mb-3">
                      <form class="form-inline justify-content-center search-input-container mb-3">
                        <div class="w-100 d-flex flex-nowrap search-input-container">
                          <input type="text" onChange={handleSearchChange} class=" form-control product-search br-30" id="input-search" placeholder="Rechercher..." />

                        </div>
                      </form>
                    </div>
                    <div className="col-12 col-sm-6 d-flex justify-content-sm-end justify-content-center mb-3 mt-sm-0 mt-3">
                     {states.userPermissions?.create_category_product !== undefined && <div>
                        <button className="btn btn-info mb-2" onClick={() => navigate("/product-category/new")}> <BiPlusMedical className="" /> Ajouter</button>
                        {/* <button className="btn btn-dark ml-3 mb-2" onClick={goToImportScreen}><AiOutlineFileExcel className="mr-1" />Importer</button> */}
                      </div>}
                    </div>
                  </div>
                </div>

                {states.productCategoriesList && 
                states.productCategoriesList?.length != 0
                // searchFunction(states.productCategoriesList, search).length != 0
                 ? 
                <CustomDatatableProductCategory 
                                onExit={reload} 
                                columns={tableColumns}
                                data={states.productCategoriesList}
                                // data={searchFunction(states.productCategoriesList, search).sort()}
                                handleCloseDeleteModal={handleCloseDeleteModal}
                                handleShowDeleteModal={handleShowDeleteModal}
                                changePage={changePage}
                                pageCount={totalPage}
                                pageNumber={pageNumber}
                                perPage={perPage}
                /> : <h4 className="py-3">Aucun résultat</h4>}
              </div>
            </div> : <div style={{ marginTop: "25%" }}>
                  <Loader />
                </div>}
          </div>
        </div>

      </div>
    </div>
  )
}

export default ProductCategory